import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { publicRoutes, privateRoutes, authRoutes, adminRoutes } from './utils/routes';
import { Suspense, useState, useEffect, useCallback } from 'react';
import { useUser } from './contexts/UserContext';
import LoadingScreen from './components/shared/LoadingScreen';
import { useCookies } from 'react-cookie';
import { getUser } from './utils/api/userAPI';
import NotFound from './pages/NotFound';
import { initializeVariables } from './utils/NormativeVariables';
import { useModal } from './contexts/ModalContext';
import HelpProvider from './features/help/context/HelpProvider';
import { connectSocket, disconnectSocket } from './services/socketService';


function App() {
  // TODO: Should not need to check if cookies exist. fix this
  const [cookies, removeCookie] = useCookies(['jwt']);
  const [loading, setLoading] = useState(true);
  const [loggedOut, setLoggedOut] = useState(false);
  const { state, dispatch } = useUser();

  const { dispatch: modalDispatch } = useModal();

  const needLogIn = useCallback(() => {
    const hasCookie = (cookies.jwt || cookies !== 'undefined') ? true : false;
    return hasCookie && !state.user;
  }, [cookies, state.user]);

  useEffect(() => {
    const loadVariables = async () => {
      try {
        await initializeVariables();
      } catch (error) {
        modalDispatch({
          type: 'SHOW_SMALL_POPUP_TOP',
          payload: {
            message: 'Failed to load variable data. Report features may not work properly. Please try refreshing the page, or contact support.',
            type: 'error',
            title: 'Error Loading Data',
          }
        })
      }
    };

    loadVariables();
  }, [modalDispatch]);

  useEffect(() => {

    const fetchData = async () => {
      try {
        if (cookies.jwt) {
          const res = await getUser();
          const data = await res.json();

          if (res.ok) {
            dispatch({ type: 'LOGIN', payload: data.user });
          } else {
            throw new Error('Error fetching user data', res.status, data.message);
          }
        } else {
          setLoggedOut(true);
        }

      } catch (error) {
        setLoggedOut(true);
        console.error(error);
        // TODO: Show error message
        dispatch({ type: 'LOGOUT_CONFIRM', payload: { message: 'Error fetching user. Please log in again.', removeCookie } });
        // removeCookie('jwt', { path: '/' });
      }
      setLoading(false);
    }

    if (needLogIn() && !loggedOut) {
      fetchData();
    } else {
      setLoading(false);
    }
  }, [cookies.jwt, dispatch, removeCookie, loggedOut, needLogIn]);

  useEffect(() => {
    if (state.user) connectSocket();
    else disconnectSocket();

    return () => disconnectSocket();
  }, [state.user]);

  return (
    <>
      {
        loading && (cookies.jwt && !state.user) ? <LoadingScreen /> :
          <Router>
            <HelpProvider>
              <Suspense fallback={<></>}>
                <Routes>
                  {publicRoutes.map((route) => (
                    <Route key={route.path} path={route.path} element={route.element} />
                  ))}
                  {privateRoutes.map((route) => (
                    <Route key={route.path} path={route.path} element={(cookies.jwt && state.user) ? route.element : <Navigate to="/" />} />
                  ))}
                  {authRoutes.map((route) => (
                    <Route key={route.path} path={route.path} element={(cookies.jwt && state.user) ? <Navigate to="/dashboard" /> : route.element} />
                  ))}
                  {adminRoutes.map((route) => (
                    <Route key={route.path} path={route.path} element={(cookies.jwt && state.user && state.user.role === 'admin') ? route.element : <NotFound />} />
                  ))}
                </Routes>
              </Suspense>
            </HelpProvider>
          </Router>
      }
    </>

  );
}

export default App;
